module.exports = __webpack_public_path__ + "static/toyota-409a43070da6c6a0c1f840719002bc33.png";